import {useQuery} from "@tanstack/react-query";
import {readCustomerCategorySelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = {};

/**
 * 소속 분류 셀렉트박스
 * @param props
 * @returns
 */
export const useReadCustomerCategorySelect = () => {
    const {data} = useQuery({
        queryKey: ["readCustomerCategorySelect"],
        queryFn: async () => await readCustomerCategorySelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
